module.exports = "/_next/static/images/granicus-logo-c76adc94d4c2a316c46aba48f5278db2.png";